function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablerIconChevronUpDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tabler-icon-chevron-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 7.5L6 4.5L3 7.5",
    stroke: "#1D2939",
    style: {
      stroke: "#1D2939",
      stroke: "color(display-p3 0.1147 0.1596 0.2226)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerIconChevronUpDark);
export default __webpack_public_path__ + "static/media/tabler-icon-chevron-up-dark.82eca5886eef765b9a8eda3aa933a014.svg";
export { ForwardRef as ReactComponent };